export default __webpack_public_path__ + "media/images/react_icons/property/coffee_machine-4ec1fa2374cdfb3a45b0b898ed68e2ce.svg";